import React, { Fragment, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import { Chip } from "@mui/material";

import { isDark } from "@common/utils/colors";

const PREFIX = "Categories";

const classes = {
  chipRoot: `${PREFIX}-chipRoot`,
  chipRootActive: `${PREFIX}-chipRootActive`,
};

const Root = styled("div")(({ theme }) => ({
  maxWidth: 524,
  height: 45,
  overflow: "hidden",
  overflowX: "scroll",
  display: "flex",
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  // marginRight: "auto",
  // marginLeft: "auto",
  WebkitOverflowScrolling: "touch",
  cursor: "grab",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    height: 4,
  },
  "&:hover": {
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: 2,
    },
  },

  [`& .${classes.chipRoot}`]: {
    backgroundColor: "#FFF",
    border: theme.bordered ? `2px solid ${theme.palette.secondary.main}` : "none",
    color: theme.palette.common.black,
    fontWeight: 500,
  },

  [`& .${classes.chipRootActive}`]: {
    color: isDark(theme.palette.secondary.main, 120)
      ? theme.palette.secondary.contrastText
      : theme.palette.primary.main,
    fontWeight: 500,
  },
}));

const Categories = (props) => {
  const { shop, category, setCategory } = props;

  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <Fragment>
      {shop && shop.use_categories && (
        <Root
          ref={scrollRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <Chip
            classes={{
              root: category === "All Categories" ? classes.chipRootActive : classes.chipRoot,
            }}
            variant={category === "All Categories" ? "default" : "outlined"}
            color={category === "All Categories" ? "secondary" : "default"}
            label="All Categories"
            onClick={() => setCategory("All Categories")}
          />
          {shop.vendor &&
            shop.vendor.product_categories.map((c, index) => (
              <Chip
                key={index}
                classes={{
                  root:
                    category === c.product_category_name
                      ? classes.chipRootActive
                      : classes.chipRoot,
                }}
                variant={category === c.product_category_name ? "default" : "outlined"}
                color={category === c.product_category_name ? "secondary" : "default"}
                label={c.product_category_name}
                onClick={() => setCategory(c.product_category_name)}
              />
            ))}
        </Root>
      )}
    </Fragment>
  );
};

export default Categories;
